// @flow
import * as React from 'react'
import { Typography } from 'antd'
import ferrarafeelings from './ferrarafeelings.jpg'
import comacchio from './comacchio.png'
import './index.css'

const { Title } = Typography

const AppHeader = () => (
  <div className="app-header">
    <figure>
      <img src={ferrarafeelings} alt="Ferrara Feelings" />
    </figure>
    <figure>
      <img src={comacchio} alt="Comacchio Po Delta Park Riviera" />
    </figure>
    <Title className="app-title sr-only">Ferrara Eventi</Title>
  </div>
)

export default AppHeader
